import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './BingoGenerator.css'
import { BINGO_LETTERS, generateBingoCard, createEmptyMarks } from './utils/bingo'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const STORAGE_KEY = 'bingoCardState'

const buildState = () => ({
  card: generateBingoCard(),
  marks: createEmptyMarks(),
})

const toggleRowMark = (marks, rowIndex, cellIndex) =>
  marks.map((row, ri) =>
    ri === rowIndex ? toggleCellInRow(row, cellIndex) : row,
  )

const toggleCellInRow = (row, cellIndex) =>
  row.map((marked, cj) => (cj === cellIndex ? !marked : marked))

const loadState = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed.card) || !Array.isArray(parsed.marks)) {
      return null
    }
    return parsed
  } catch {
    return null
  }
}

const BingoGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de Cartela de Bingo Online e Grátis',
    description:
      'Gere cartelas de bingo únicas (estilo B-I-N-G-O), marque os ' +
      'números clicando e imprima quando quiser  grátis, direto no ' +
      'navegador.',
  })

  const [state, setState] = useState(() => loadState() || buildState())

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  }, [state])

  const regenerate = () => {
    setState(buildState())
    trackEvent('tool_generate', { tool: 'bingo' })
  }

  const toggleMark = (rowIndex, cellIndex) => {
    setState((current) => ({
      ...current,
      marks: toggleRowMark(current.marks, rowIndex, cellIndex),
    }))
  }

  return (
    <div className="tool-page">
      <div className="bingo-controls-wrapper">
        <Link to="/ferramentas" className="tool-back-link">
          ← Todas as ferramentas
        </Link>
        <h1>Cartela de Bingo Digital</h1>
        <p className="tool-disclaimer">
          Cartela única no estilo B-I-N-G-O (1 a 75). Clique em um número
          pra marcar durante o jogo  a marcação fica salva mesmo se você
          atualizar a página, até você gerar uma cartela nova.
        </p>

        <div className="bingo-actions">
          <button type="button" className="tool-button" onClick={regenerate}>
            Gerar nova cartela
          </button>
          <button
            type="button"
            className="tool-button tool-button-secondary"
            onClick={() => {
              trackEvent('tool_print', { tool: 'bingo' })
              window.print()
            }}
          >
            Imprimir
          </button>
        </div>
      </div>

      <div className="bingo-cards">
        <table className="bingo-card">
          <thead>
            <tr>
              {BINGO_LETTERS.map((letter) => (
                <th key={letter}>{letter}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {state.card.map((row, rowIndex) => (
              <tr key={`row-${rowIndex}`}>
                {row.map((cell, cellIndex) => {
                  const isFree = cell === 'FREE'
                  const marked = isFree || state.marks[rowIndex][cellIndex]
                  return (
                    <td
                      key={`cell-${rowIndex}-${cellIndex}`}
                      className={[
                        isFree ? 'bingo-free' : '',
                        marked ? 'bingo-marked' : '',
                      ]
                        .filter(Boolean)
                        .join(' ')}
                      onClick={
                        isFree ? undefined : () => toggleMark(rowIndex, cellIndex)
                      }
                    >
                      {cell}
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="tool-info-section">
        <h2>Como funciona a cartela</h2>
        <p>
          Segue o padrão americano de bingo 75 bolas: a coluna B recebe
          números de 1 a 15, a coluna I de 16 a 30, a N de 31 a 45 (com o
          espaço central livre), a G de 46 a 60 e a O de 61 a 75  cada
          coluna sorteada sem repetição. Toda vez que você clica em
          "Gerar nova cartela" os números são sorteados de novo do zero.
        </p>
        <p>
          A marcação feita ao clicar nos números fica salva no seu
          navegador (localStorage), então dá pra atualizar a página no
          meio do jogo sem perder o progresso. Use o botão "Imprimir"
          para gerar uma versão em papel da cartela.
        </p>
      </div>
    </div>
  )
}

export default BingoGenerator
